var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroller",attrs:{"id":"home_wrapper"}},[_c('div',{staticClass:"position-relative bg-yellow",attrs:{"id":"home"}},[_c('HeroRooms'),_vm._v(" "),_c('Amenities'),_vm._v(" "),_c('Chambres',{attrs:{"id":"chamber"}}),_vm._v(" "),_c('AppFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }